module.exports = __webpack_public_path__ + "img/Masked Icon.c437085b.svg";